import { render, staticRenderFns } from "./PAYGPlanSettings.vue?vue&type=template&id=43e64497&"
import script from "./PAYGPlanSettings.vue?vue&type=script&lang=js&"
export * from "./PAYGPlanSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports